export default {
  globalUi: {
    isHeaderOpen: false,
  },
};



// WEBPACK FOOTER //
// ./utils/constants/initialState.js